module.exports = __webpack_public_path__ + "img/near_cyl125_axis90.88430a2b.jpg";